/** Entry point. */

import { App } from "./game/app";

const canvas = document.querySelector<HTMLCanvasElement>("#game");
const app = document.querySelector<HTMLElement>("#app");
if (!canvas || !app) throw new Error("#game canvas or #app container not found");

new App(canvas, app).start();
